import { render } from "./AddDiscountCodeForm.vue?vue&type=template&id=fbced906"
import script from "./AddDiscountCodeForm.js?vue&type=script&lang=js"
export * from "./AddDiscountCodeForm.js?vue&type=script&lang=js"

import "./AddDiscountCodeForm.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__